import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"
import NewsCard from "../components/news_card"
import { RichText, Date } from "prismic-reactjs"
import Header from "../components/header.js"
import Photo from "../components/photo"
import RightArrow from "../svg/right-circle.svg"
import DevelopmentUpdateForm from '../components/developmentUpdateForm'

class developmentUpdates extends React.Component {
   componentDidMount() {
      this.props.updateMeta(
         this.props.data.prismicDevelopmentUpdates.data.meta_title.text,
         this.props.data.prismicDevelopmentUpdates.data.meta_description
      )
      this.props.togglePopup(false);
      this.props.updateProductHide(false);
      this.props.updateFooterVisible(true);
   }

   render() {
      let data = this.props.data.prismicDevelopmentUpdates.dataString
      data = JSON.parse(this.props.data.prismicDevelopmentUpdates.dataString)
      const slides = [
         {
            img: {
               alt: "",
               url: `${data.body[0].primary.hero_image.url}`,
               mobile: {
                  url: `${data.body[0].primary.hero_image.url}`
               }
            },
            logo: {},
            image_anchor: "Top",
            header: [
               {
                  type: "heading2",
                  text: `${data.body[0].primary.header[0].text}`,
                  spans: []
               }
            ],
            subheader: [
               {
                  type: "heading3",
                  text: `${data.body[0].primary.subheader[0].text}`,
                  spans: []
               }
            ],
            text: data.body[0].primary.text,
            link: null
         }
      ]

      return (
         <div>
            <Header theme="dark" menu={this.props.data.prismicMainNavigation.data} />
            <div className="bg mini white">


               <Photo slides={slides} hero="false" key={0} />
               {/* <NewsCard
                     imageUrl={data.body[0].primary.hero_image.url}
                     titleRight={data.body[0].primary.header[0].text}
                     text={RichText.render(data.body[0].primary.text)}
                     actionUrl=""
                     showSeparator={true}
                     layout="main"
                     sub={data.body[0].primary.header[0].text}
                     btn="Discover more"
                  /> */}
            <Container isHero={false}>
               <div className="grid ">
                  <div className="inner" >
                     <MainCopy className="col col-xs-12 col-06 ">
                              {slides[0].logo && (
                              <img src={slides[0].logo.url} />
                              ) }
                        {RichText.render(slides[0].header)}

                        {RichText.render(slides[0].subheader)}
                     </MainCopy>
                     <Text  className="col col-xs-12 col-04">
                        {RichText.render(slides[0].text)}
                        <DevelopmentUpdateForm />
                     </Text>
                  </div>
               </div>
            </Container>
               <DocContainer className="grid">
                  {/* {console.log(data.body)} */}
                  {data.body[0].items.map(m => {
                     return (
                        <h3>
                           <a href={m.document_link.url} target="_blank">
                              <span>{m.document_title[0].text}</span>
                           </a>
                        </h3>
                     )
                  })}

               </DocContainer>
            </div>
         </div>
      )
   }
}

const DocContainer = styled.div`
   /* border: 1px solid gray; */

   h3 {
      padding: 1rem 1rem;
      width: 100%;
      border: 1px solid ${vars.colors.offColor};
      border-width: 1px 0 0 0;

      &:last-of-type {
         border-bottom: 1px solid ${vars.colors.offColor};
      }

      a {
         display: block;
         text-decoration: none;
         position: relative;
         padding: 1rem 0;
					span{
						max-width: calc(100% - 5rem);
						display: inline-block;
					}
         &:after {
            content: "";
            width: 3rem;
            height: 3rem;
            /* margin-top: .3rem; */
            background: url(${RightArrow}) no-repeat;
            position: absolute;
            transform: translate(-50%, -50%);
            right: 0;
            top: 50%;
         }
      }
   }

   .btn {
      background: ${vars.colors.body};
      color: white;
      /* width: 48rem; */
      margin: 3rem 0 7rem;

      ${below.mobile`
         width: 28rem;
      `};
   }

   .btn.btn-square span {
      /* display: block; */
      text-align: center;

      ${below.mobile`
         font-size: 1.2rem;
      `};
   }

   margin-bottom:7rem;
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-right: ${props => props.isHero ? '1' : '1'}px solid ${vars.colors.body};
	img{
		width: 200px;
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
   `};

`
const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
`

const Container = styled.div`

   padding-bottom: ${vars.padding.inner * 2}rem;

   h3 {
		font-family: ${vars.fonts.main};
		font-weight:normal;

		font-size:2.3rem;
		font-weight: normal;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
      padding-bottom: ${vars.padding.mobInner}rem;
   }
	 .grid .col{
		 min-height: 30rem;
		 ${below.tablet`
		 	min-height: 0;
			 padding-left: ${vars.padding.mobInner}rem;
			 border-left: 1px solid ${vars.colors.body};

		 `}
	 }
   .grid .col:first-of-type {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
			${below.tablet`
				padding-left: ${vars.padding.mobInner}rem;
			`}
   }

   .border-left {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
   }
   .mob-border-left {
      border-left-width: 0;
			padding-left: ${vars.padding.inner}rem;

      ${below.tablet`
         border-left-width: 0.2rem;
      `}
   }
`


export default developmentUpdates

export const pageQuery = graphql`
   query developmentUpdates($id: String) {
      prismicDevelopmentUpdates(id: { eq: $id }) {
         id
         dataString
         data {
            meta_title {
               html
               text
            }
            meta_description
         }
      }
      prismicMainNavigation {
         id
         dataString
         data {
           display_name {
             html
             text
           }
           nav {
             slice_type
             primary {
               label {
                 text
               }
               link {
                 text
               }
             }
             items {
               sub_nav_link_label {
                 text
               }
               sub_nav_link {
                 text
               }
             }
           }
         }
       }
   }
`



// WEBPACK FOOTER //
// ./src/templates/developmentUpdates.js